import { render, staticRenderFns } from "./simulador.html?vue&type=template&id=79fdf04a&scoped=true&"
import script from "./simulador.js?vue&type=script&lang=js&"
export * from "./simulador.js?vue&type=script&lang=js&"
import style0 from "./simulador.scss?vue&type=style&index=0&id=79fdf04a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fdf04a",
  null
  
)

export default component.exports